import { PayloadAction } from '@reduxjs/toolkit'
import api from '../../agent'
import create from './base'
import moment from 'moment/moment'
import {ODDS_TAB_INDEX} from "../../utils";

export interface SettingsState {
    notifications_config: {
        available: boolean;
        enabled: boolean;
    }
    notification_settings: {
        live: {
            pending: boolean;
            win: boolean;
            lost: boolean;
        }
        time: {
            start: string;
            end: string;
        }
    },
    activePage: string,
    gameActiveTab: number
}

const getLastPathSegment = (url: string) => {
    const urlObj = new URL(url);
    const pathname = urlObj.pathname;
    const pathSegments = pathname.split('/');

    // If the last segment is empty (e.g. the URL ends with a trailing slash),
    // return the preceding segment instead.
    return pathSegments[pathSegments.length - (pathSegments[pathSegments.length - 1] === '' ? 2 : 1)];
}

const capitalize = (str: any) => {
    return str?.charAt(0).toUpperCase() + str?.slice(1).toLowerCase();
}

const SettingsRedux = create('settings', {
    value: 0,
    notifications_config: {
        available: !!window.Notification && 'permission' in window.Notification,
        enabled: !!window.Notification && window.Notification.permission === 'granted'
    },
    notification_settings: {
        live: {
            pending: true,
            win: true,
            lost: true
        },
        time: {
            start: '08:00',
            end: '22:00'
        }
    },
    activePage: capitalize(getLastPathSegment(window.location.href)) || 'Live',
    gameActiveTab: ODDS_TAB_INDEX
}, {
    enable: (state: SettingsState, action: PayloadAction<number>) => {
        state.notifications_config.enabled = true
    }

}, {
    subscribe: async (state: SettingsState, params: any = {}) => {
        if (!params.hasOwnProperty('token')) {
            params.token = localStorage.getItem('notifications_token')
        }
        const timezone = moment.tz.guess()
        const user_agent = window?.navigator?.userAgent || 'unknown'

        localStorage.setItem('notifications_token', params.token)
        
        const response = await api.subscribeNotifications(params.token,user_agent,timezone)
        
        return {
            notification_settings: response.data.settings
        }
    },
    saveSettings: async (state: SettingsState, params: any = {}) => {
        const result = (await api.saveNotificationsSettings(params)).data
        
        return {
            notification_settings: params
        }
    },
    updatePageState: async (state: SettingsState, params: any = {}) => ({
        activePage: params
    }),
    updateGameActiveTab: async (state: SettingsState, activeTab: number) => ({
        gameActiveTab: activeTab
    }),
})

export const {
    enable,
    subscribe,
    saveSettings,
    updatePageState,
    updateGameActiveTab
} = SettingsRedux.actions

export default SettingsRedux.reducer
